import * as React from 'react'

type Props = {
  children: React.ReactNode
  className?: string
}

const Centered = (props: Props) => (
  <div
    className={props.className}
    style={{
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      alignItems: 'center',
    }}>
    {props.children}
  </div>
)

export default Centered
